import loadBasketModule from './modules/Basket.module';
import loadCompareModule from './modules/Compare.module';
import loadWishListModule from './modules/WishList.module';
import loadDeliveryPromiseModule from './modules/DeliveryPromise.module';
const loadWishlistListerModule = () => ({
    hasRouter: true,
    modules: [loadWishListModule(), loadCompareModule(), loadBasketModule(), loadDeliveryPromiseModule()],
});
export default loadWishlistListerModule;
